<div class="flex min-h-screen min-w-screen w-full flex-wrap items-center justify-center overflow-y-auto p-4">

  @if(authService.isUserGlobalAdmin) {
  <fuse-card (click)="redirectToGlobal()"
    class="filter-article m-2 flex flex-col w-1/4 max-h-60 cursor-pointer">
    <div class="h-50 overflow-hidden">
      <img class="object-cover p-4"
        [src]="'../../../../assets/images/carpro.png'" />
    </div>
    <div class="m-4 h-10 text-center items-center content-center">
      <div class="text-2xl font-semibold leading-tight">
        Global Admin Dashboard
      </div>
    </div>
  </fuse-card>
  }

  @if(authService.mandats.length === 0 && !authService.isUserGlobalAdmin) {
    <section class="mx-auto flex w-full max-w-2xl flex-col items-center px-6 py-12 text-center">
      <div
        class="mb-8 flex h-28 w-28 items-center justify-center rounded-full border border-primary-200 bg-primary-50 shadow-sm dark:border-primary-500/30 dark:bg-primary-500/10">
        <mat-icon
          class="icon-size-14 text-primary-600 dark:text-primary-400"
          [svgIcon]="'heroicons_outline:building-office-2'">
        </mat-icon>
      </div>

      <h1 class="text-3xl font-semibold tracking-tight text-slate-900 dark:text-white sm:text-4xl">
        {{ 'ChooseMandat.NoMandatsTitle' | transloco }}
      </h1>
      <p class="mt-4 max-w-xl text-lg leading-7 text-secondary sm:text-xl">
        {{ 'ChooseMandat.NoMandatsDescription' | transloco }}
      </p>

      <button
        class="fuse-mat-rounded mt-8 min-w-44 !bg-primary px-7 !text-white shadow-md transition-all duration-200 hover:-translate-y-0.5 hover:!bg-primary-dark hover:shadow-lg"
        mat-flat-button
        type="button"
        (click)="signOut()">
        <mat-icon
          class="mr-2 icon-size-5 text-white"
          [svgIcon]="'heroicons_outline:arrow-right-on-rectangle'">
        </mat-icon>
        {{ 'ChooseMandat.SignOut' | transloco }}
      </button>
    </section>
  }
  @else {
    @for (mandat of authService.mandats; track $index) {
    <fuse-card (click)="redirectToMandat(mandat.Id)"
      class="filter-article m-2 flex flex-col w-1/4 max-h-60 cursor-pointer">
      <div class="h-50 overflow-hidden">
        <img
          class="object-cover p-4"
          [src]="mandat.Avatar ?? '../../../../assets/images/carpro.png'"
          alt="Mandat image" />
      </div>
      <div
        class="m-4 h-10 text-center items-center content-center">
        <div class="text-2xl font-semibold leading-tight">
          {{mandat.Name}}
        </div>
      </div>
    </fuse-card>
    }
  }

</div>
